import React from 'react';
import { Link } from 'react-router-dom';
import { Heading } from 'elements';
import momentDate from 'utils/momentDate';
import tulkojumi from 'utils/tulkojumi';
import { StyledFlexHeader, StyledFlex, StyledMainAnchor, StyledItem, StyledHeading, StyledGroup, StyledKontakts,StyledItemAnchor } from './styled';
import {  FlexItem } from 'core/layout'
import { Anchor } from 'elements'



class KontaktuRezultatsItem extends React.PureComponent {
    state = {
      id: 0
    }



    _renderContacts = (acf, key) => {
        const { teksti } =this.props

        return (

            acf[key] && acf[key].map((div, div_i) => {
                
                let show_heads = false

                if(div && div.kontakts && div.kontakts[0]){
                    show_heads = div.kontakts.filter(kontakts => kontakts.vards_uzvards !== '').length > 0
                    
                }

                return div?(
                <StyledGroup key={div_i}>
                    <div>
                        {div.nosakums!==''?<h3>{div.nosakums}</h3>:null}
                        {
                           div.kontakts && div.kontakts[0] && div.nosakums==='' && show_heads ? <StyledFlexHeader>
                                                                                            <FlexItem basis={4/7}>
                                                                                             {tulkojumi(teksti, 'amats')}
                                                                                            <br/>
                                                                                            {tulkojumi(teksti, 'epasts')}
                                                                                            </FlexItem>


                                                                                            <FlexItem basis={3/7}>
                                                                                            {tulkojumi(teksti, 'vards')}, {tulkojumi(teksti, 'uzvards')}
                                                                                            <br/>
                                                                                            {tulkojumi(teksti, 'telefons')}
                                                                                            </FlexItem>
                                                                                </StyledFlexHeader>:null
                        }
                        {div.kontakts && div.kontakts[0] ?div.kontakts.map((kontakts, kontakts_i) => {
                                    return kontakts.amats!==''&&kontakts.vards_uzvards!==''?
                                    <StyledFlex key={kontakts_i}>

                                        <FlexItem basis={4/7}>
                                        {kontakts.amats}
                                        <br/>
                                        <Anchor href={ kontakts['e-pasts'].replace(/\s/g,'').indexOf('@')>0?`mailto:${kontakts['e-pasts'].replace(/\s/g,'')}`:`tel:${kontakts['e-pasts'].replace(/\s/g,'')}` }>{ kontakts['e-pasts'] }</Anchor>
                                        </FlexItem>


                                        <FlexItem basis={3/7}>
                                        {kontakts.vards_uzvards}
                                        <br/>
                                        <Anchor href={ kontakts.telefons.replace(/\s/g,'').indexOf('@')>0?`mailto:${kontakts.telefons.replace(/\s/g,'')}`:`tel:${kontakts.telefons.replace(/\s/g,'')}` }>{ kontakts.telefons }</Anchor>
                                        </FlexItem>


                                    </StyledFlex>:null
                                })

                        :null}
                    </div>
                </StyledGroup>):null
            }
        )
    )
    }


    render() {
        const {
            postType,
            lang,
            _id,
            path,
            title,
            new_term,
            date_created,
            terms,
            acf,
            teksti,
            _toggleRow,
            opened,
        } = this.props;

        let acfData;
        try {
          acfData = acf && JSON.parse(acf);
        } catch (error) { }



        return new_term?
                (<StyledItem className={ opened?'opened title':'title' } >
                    <StyledItemAnchor name={terms.kontakti_iestades[0].slug} id={terms.kontakti_iestades[0].slug}><h2>{terms.kontakti_iestades[0].name}</h2></StyledItemAnchor>
                    {title&&title!==''?<StyledHeading>
                        <StyledMainAnchor className={ opened?'opened':'' } href='' onClick={ event => _toggleRow(event, _id) } >{title}</StyledMainAnchor>
                    </StyledHeading>:null}
                    {this._renderContacts(acfData, 'nodala')}
                </StyledItem>)
                :
                (<StyledItem className={ opened?'opened':'' } >
                {title&&title!==''?
                <StyledHeading>
                    <StyledMainAnchor className={ opened?'opened':'' } href='' onClick={ event => _toggleRow(event, _id) } >{title}</StyledMainAnchor>
                </StyledHeading>:null}
                    {this._renderContacts(acfData, 'nodala')}
                </StyledItem>)

    }
}

export default KontaktuRezultatsItem;



// WEBPACK FOOTER //
// ./src/pages/KontaktiRezultati/components/KontaktuRezultatsItem/KontaktuRezultatsItem.jsx